interface ProfileOnboardingProps {
  renderOnboarding?: () => React.ReactNode
}

export function ProfileOnboarding({ renderOnboarding }: ProfileOnboardingProps) {
  return <div>{renderOnboarding?.()}</div>
}
